import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD65yFkIotMY7sNS5hy8gVrLKMCi2BzXx4",
  authDomain: "expert-advance-trade-pro.firebaseapp.com",
  projectId: "expert-advance-trade-pro",
  storageBucket: "expert-advance-trade-pro.appspot.com",
  messagingSenderId: "898736470757",
  appId: "1:898736470757:web:fa42aa2fb17a41d04af20c",
};

// const firebaseConfig = {
//   apiKey: "AIzaSyDtmNsjSnruKS6ZCs3jwqec0QMqGqGKQWk",
//   authDomain: "finance-v2-e1682.firebaseapp.com",
//   projectId: "finance-v2-e1682",
//   storageBucket: "finance-v2-e1682.appspot.com",
//   messagingSenderId: "133386766551",
//   appId: "1:133386766551:web:e0236afa4a4dc881e20892",
// };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
